import { Component, Input, Output, EventEmitter, HostBinding, ChangeDetectionStrategy } from '@angular/core';
import { iconColors, iconSizes } from '@app/shared/constants';

@Component({
  selector: 'remove-button',
  templateUrl: 'remove-button.component.html',
  styleUrls: ['remove-button.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class RemoveButtonComponent {
  @Input()
  @HostBinding('class.transparent-bg')
  public transparentBackground: boolean;

  @Input()
  public changeOnHover: boolean;

  @Input()
  @HostBinding('class.focusable')
  public isFocusable: boolean;

  @Input()
  @HostBinding('class.match-width')
  public matchWidth: boolean;

  @Input()
  @HostBinding('class.no-flex')
  public noFlex: boolean;

  @Input()
  @HostBinding('class.disabled')
  public disabled = false;

  @Input()
  @HostBinding('class.btn-mode')
  public btnMode = false;

  @Input()
  public colorClassName = iconColors.GREY;

  @Input()
  public size = iconSizes.DEFAULT;

  @Input()
  @HostBinding('class.no-margin')
  public noCrossMargin: boolean;

  @Input()
  public stopPropagation = true;

  @Input()
  public pending: boolean;

  @Input()
  public useText = false;

  @Input()
  public autId?: string;

  @Output()
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  public onClick = new EventEmitter<any>();

  public clicked($event: Event): void {
    if (this.stopPropagation) {
      $event.preventDefault();
      $event.stopPropagation();
    }
    if (this.disabled) {
      return;
    }
    this.onClick.emit($event);
  }

  public iconColors = iconColors;
}
